<template>
    <div>
        <div class="phone-class-list" :class="{'mobile-article-list':isMobile}">
            <a-row :gutter="{ xs: 16, sm: 16, md: 16, lg: 16 }">
                <div v-if="title">
                    <header>
                        <img class="title-icon"  src="@assets/img/index/headline-pick.png" alt="">
                        <span class="title-course">{{title}}</span>
                        <span class="more-course">
                            <router-link :to="{path:'other/article'}">
                                更多 <a-icon type="right-circle" />
                            </router-link>
                        </span>
                    </header>
                </div>

                <ul v-if="isLoading">
                    <li class="col" v-for="item in pageSize " :key="item">
                        <a-col>
                            <Spin class="spin" />
                        </a-col>
                    </li>
                </ul>

                <ul v-else>
                    <li class="col" v-for="item in articleList " :key="item.articleId">
                        <!--                        <a-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="col">-->
                            <ArticleListItem :article-info="item" />
                    </li>
                </ul>

            </a-row>

        </div>
    </div>
</template>

<script>
    import Spin from "@components/loading/Spin";
    import {listArticle} from "@api/article";
    import {SUCCESS} from "@constants/code";
    import ArticleListItem from "@components/article/ArticleListItem";
    import common from "../../mixin/common";

    export default {
        name: "ArticleList",
        components: {
            ArticleListItem,
            Spin
        },
        mixins: [common],
        data() {
            return {
                isLoading: false,
                articleList: [],
                pageNum: 1,
                pageSize: 5,
                total: 0
            };
        },
        created() {
            // 加载文章数据
            this.isLoading = true;
            if (this.isMobile) {
                this.pageSize = 6
            }
            listArticle(this.params, this.pageNum, this.pageSize).then(res => {
                if (res.code === SUCCESS) {
                    this.articleList = res.rows;
                    this.total = res.total;
                }
                this.isLoading = false;
            });
        },
        props: {
            params: {
                default() {
                    return {}
                }
            },
            title: String
        }
    }
</script>

<style scoped lang="less">
    @import "../../styles/course.less";

    .col {
        margin-bottom: 10px;
    }

    .spin {
        /*width: 220px;*/
        /*height: 250px;*/
        /*width: 50%;*/
        margin: 20px 0;
    }

    .phone-class-list {
        width: 1160px;
        background: #fff;
        padding: 30px 20px;
        margin: 15px auto 0;
        border-radius: 20px;

        header {
            display: flex;
            align-items: center;
            font-size: 24px;
            padding: 0 12px 10px 0;
            border-bottom: 2px solid #e8e8e8;
          .title-course{
            font-weight: 600;
          }
          .title-icon{
            width: 38px;
            margin-right: 15px;
          }
        }

        img {
            width: 100%;
        }

        ul li {
            margin-top: 20px;
        }


      .col {
        width: 19%;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.15);
        border-radius: 10px;
        float: left;
        margin: 14px 0.5% 0;
      }
    }

    header {
        font-size: 24px;
        /*text-align: center;*/
        /*margin: 0 0 20px;*/
    }


    .title-course {

    }

    .more-course {
      margin-left: auto;
        font-size: 16px;
        line-height: 34px;

        a {
            color: #999999;
        }
    }

    .more-course:hover {
        cursor: pointer;
        color: #00CF8C;
    }

    // 移动端样式
    .mobile-article-list {
        width: 100%;
        padding: 10px 20px;
      .col {
        width: 48%;
        margin: 14px 1% 0;
      }

      header{
        .title-icon{
          width: 33px;
          margin-right: 15px;
        }
        .title-course{
          font-weight: 600;
          font-size: 18px;
        }
      }
    }

    /*@media (max-width: 992px) {*/
    /*}*/

    /*@media (max-width: 576px) {*/
    /*    header {*/
    /*        text-align: left;*/
    /*    }*/

    /*}*/

    /*@media (min-width: 768px) {*/

    /*}*/

    /*@media (min-width: 992px) {*/
    /*    .phone-class-list {*/
    /*        padding: 10px 20px;*/
    /*    }*/
    /*}*/

    /*@media (min-width: 1200px) {*/
    /*    .phone-class-list {*/
    /*        padding: 10px 50px;*/
    /*    }*/
    /*}*/

    /*@media (min-width: 1600px) {*/
    /*    .phone-class-list {*/
    /*        padding: 10px 100px;*/
    /*    }*/
    /*}*/
</style>
